module.exports = __webpack_public_path__ + "img/cry-emoji.087845c1.png";